import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Header from "../../Header/Header";
import { Link } from "react-router-dom";
import {
	FaArrowRight,
	FaCogs,
	FaPlus,
	FaTruck,
	FaUser,
} from "react-icons/fa";
import Footer from "../../../Components/Footer/Footer";

const BecomeASeller = () => {
	const containerRef = useRef(null);

	const { scrollYProgress } = useScroll({
		target: containerRef,
		offset: ["start start", "end start"],
	});

	const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "40%"]);
	const contentY = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);

	return (
		<div ref={containerRef} className="font-sans bg-gray-100 min-h-screen">
			<Header />

			{/* 🔹 HERO PARALLAX */}
			<div className="relative h-[60vh] overflow-hidden">
				<motion.img
					src="/assets/about-us.jpg"
					alt="Become a Seller"
					style={{ y: imageY }}
					className="absolute inset-0 w-full h-full object-cover"
				/>

				<div className="absolute inset-0 bg-green-900/60 flex flex-col justify-center items-start px-6 md:px-16">
					<motion.h1
						initial={{ opacity: 0, y: 30 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}
						className="text-white text-3xl md:text-5xl font-bold mb-4 max-w-3xl"
					>
						Launch your online selling business with confidence
					</motion.h1>

					<Link
						to="/seller-sign-up"
						className="bg-green-500 text-white py-3 px-8 rounded-full text-lg hover:bg-green-700 transition"
					>
						Start Selling
					</Link>
				</div>
			</div>
			<motion.div style={{ y: contentY }} className="relative z-10 -mt-24">
				<motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }} transition={{ duration: 0.6 }}
					className="bg-white max-w-6xl mx-auto shadow-xl p-8 md:p-12 grid md:grid-cols-2 gap-10 mb-16"
				>
					<img src="assets/become1.png" alt="" />
					<div>
						<h2 className="text-3xl font-bold mb-4">
							Your one-stop shop for quality products
						</h2>
						<p className="text-gray-700">
							Zakkuu provides seamless navigation, rich visuals and smooth
							operations so you can focus on growing your business.
						</p>
					</div>
				</motion.div>
				<motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }} transition={{ duration: 0.6 }}
					className="max-w-6xl mx-auto p-8 md:p-12 grid md:grid-cols-2 gap-10 mb-16"
				>
					<div>
						<h2 className="text-3xl font-bold mb-4">
							Simplified Payment Solution
						</h2>
						<p className="text-gray-700">
							Track transactions clearly and scale your business confidently
							with Zakkuu.
						</p>
					</div>
					<img src="assets/become2.png" alt="" />
				</motion.div>
				<motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }} transition={{ duration: 0.6 }}
					className="bg-white max-w-6xl mx-auto shadow-xl p-8 md:p-12 grid md:grid-cols-2 gap-10 mb-16"
				>
					<img src="assets/become3.png" alt="" />
					<div>
						<h2 className="text-green-600 text-3xl font-bold mb-4">
							Focus on Your Brand’s Success
						</h2>
						<p className="text-gray-700">
							Tailored solutions and expert support to help your brand grow.
						</p>
					</div>
				</motion.div>
				<motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }} transition={{ duration: 0.6 }}
					className="max-w-6xl mx-auto text-center mb-16"
				>
					<h2 className="text-3xl font-bold mb-10">
						How to Start Your Online Business
					</h2>
					<div className="flex flex-col md:flex-row justify-center items-center gap-8">
						{[
							{ icon: <FaUser />, text: "Create account" },
							{ icon: <FaCogs />, text: "Storage & shipping" },
							{ icon: <FaPlus />, text: "Add products" },
							{ icon: <FaTruck />, text: "Deliver & earn" },
						].map((step, i) => (
							<div key={i} className="flex items-center">
								<div className="flex flex-col items-center">
									<div className="bg-green-500 text-white p-4 rounded-full text-2xl mb-2">
										{step.icon}
									</div>
									<p>{step.text}</p>
								</div>
								{i !== 3 && <FaArrowRight className="mx-6 hidden md:block" />}
							</div>
						))}
					</div>
				</motion.div>
				<motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
					transition={{ duration: 0.8 }} className="relative h-[50vh]"
				>
					<img src="assets/becomelast.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
					<div className="absolute inset-0 bg-white/70 flex flex-col justify-center items-center text-center px-6">
						<h2 className="text-3xl md:text-4xl font-bold mb-6">
							Become a Seller on Zakkuu & Grow Your Business
						</h2>
						<Link
							to="/seller-sign-up"
							className="bg-green-500 text-white py-3 px-8 rounded-full text-lg hover:bg-green-700 transition"
						>
							Start Selling
						</Link>
					</div>
				</motion.div>
			</motion.div>
			<Footer />
		</div>
	);
};

export default BecomeASeller;
